module.exports = __webpack_public_path__ + "img/caas3.3f5198f3.jpg";